import React, { useEffect, useRef } from "react";
import VoiceRecord from "./VoiceRecord";
import Image from "./Image";
import Text from "./Text";
import AIChat from "./AIChat";
import Website from "./Website";
import Document from "./Document";
import Instagram from "./Instagram";
import Youtube from "./Youtube";
import Tiktok from "./Tiktok";
import Group from "./Group";
import Facebook from "./Facebook";
import { useContext } from "react";
import { DarkModeContext } from "../context/DarkModeContext";
const SideBar = () => {
  const { darkMode } = useContext(DarkModeContext);
  const sidebarRef = useRef(null);
  useEffect(() => {
    const sidebarElement = sidebarRef.current;

    // Ensure sidebarElement is not null before adding the event listener
    if (sidebarElement) {
      const handleWheel = (event) => {
        if (event.ctrlKey) {
          event.preventDefault(); // This prevents the zooming behavior
        }
      };

      // Add the wheel event listener without the passive option
      sidebarElement.addEventListener("wheel", handleWheel, { passive: false });

      // Clean up the event listener when the component unmounts
      return () => {
        sidebarElement.removeEventListener("wheel", handleWheel);
      };
    }
  }, []);

  // Using light mode colors based on the reference image
  const colors = {
    background: darkMode ? "#f8f8f8" : "#222222",
    contentBackground: darkMode ? "#ffffff" : "#2a2a35",
    iconColor: darkMode ? "#555555" : "#858597",
  };

  return (
    <div
      ref={sidebarRef}
      className="fixed top-40 bottom-28 gap-3 w-auto flex flex-col z-10"
    >
      <div
        className="p-1 bg-opacity-50 rounded-[10px]"
        style={{
          background: colors.background,
          pointerEvents: "auto",
        }}
      >
        <AIChat />
      </div>
      <div
        className="flex flex-col flex-wrap items-stretch justify-around p-1 gap-2 bg-opacity-50 rounded-[10px]"
        style={{
          background: colors.background,
          pointerEvents: "auto",
        }}
      >
        <VoiceRecord />
        <Image />
        <Youtube />
        <Tiktok />
        <Instagram />
        <Facebook />
        <Website />
        <Text />
        <Document />
        <Group />
      </div>
    </div>
  );
};

export default SideBar;
